import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import 'react-select/dist/react-select.css';

const RenderMultiSelectInput = ({
    className,
    input,
    options,
    label,
    meta: { touched, error } = {},
    ...rest
  }) => {

  const handleChange = (option) => {
    input.onChange(option.map(opt => opt.value))
  }

  return (
    <div className="form-group">
      {label !== '' && <label>{label}</label>}
      <Select
        multi
        value={input.value}
        onChange={handleChange}
        className="basic-multi-select"
        classNamePrefix="select"
        options={options.map(opt => ({ value: opt.value, label: opt.displayName }))}
        {...rest}
      >
      </Select>
    </div>
  )
}

RenderMultiSelectInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.any.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  meta: PropTypes.any,
}

RenderMultiSelectInput.defaultProps = {
  label: '',
}

export default RenderMultiSelectInput



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderMultiSelectInput.js